import PRODUCT_TYPE from "../const/products";
var isPayLaterLoanType = function (type) {
    if (!type)
        return false;
    var payLaterLoanTypes = [
        PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY,
        PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR,
    ];
    return payLaterLoanTypes.includes(type);
};
export default isPayLaterLoanType;
//# sourceMappingURL=isPayLaterLoanType.js.map